import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal-consulta-ajustadores',
    templateUrl: './modal-consulta-ajustadores.component.html',
    styleUrls: ['./modal-consulta-ajustadores.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, MatPaginator]
})
export class ModalConsultaAjustadoresComponent {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public displayColumns = ['No', 'Nombre', 'Motivo', 'Fecha', 'Hora'];
  public datoAjustadores = new MatTableDataSource<any>([]);

  private listaObservables = new Subscription();
  public selectAjustadorDatos = null;

  constructor(
    public dialogRef: MatDialogRef<ModalConsultaAjustadoresComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    @Inject(MAT_DIALOG_DATA) public data: { tipoCliente: number },
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngOnInit(): void {

  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      // this.detalleSiniestro = { ...detalleSiniestro };
      this.consultarAjustadores(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string, valor?) {
    if (opcion == 'Cancelar') this.dialogRef.close(valor);
    if (opcion == 'Aceptar') this.dialogRef.close(valor);
  }

  seleccionarAjustador(lesionado) {
    this.selectAjustadorDatos = lesionado;
  }

  consultarAjustadores(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaAjustadores(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Ajustadores.length) {
          this.datoAjustadores = new MatTableDataSource(value.Resultado.Ajustadores ?? []);
          this.datoAjustadores.paginator = this.paginator;
        } else {
          this.datoAjustadores = new MatTableDataSource([]);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los lesionados.' }));
      },
    })
  }
}
